import React from "react";
import loadable from "@loadable/component";
import { useAppState } from "@state";
import { Container, ButtonAlt } from "@atoms";
import { HeadingWIcon, PressTease } from "@molecules";

const SearchModal = loadable(() => import("@organisms/SearchModal"));

const PressGrid = ({ data: press, headingStyles, className }) => {
  const [, dispatch] = useAppState();

  const openSearch = () =>
    dispatch({
      type: "openModal",
      // eslint-disable-next-line react/no-unstable-nested-components
      content: React.memo(() => (
        <SearchModal
          content={press.documents.map((a, i) => {
            return { ...a, id: i };
          })}
          placeholder="Search Press"
          resultCard={PressTease}
          param="qp"
          backCopy="Go to All Resources"
        />
      )),
    });

  return (
    <div className={className}>
      <Container>
        <div className="flex flex-wrap justify-between">
          <div className="w-full md:w-2/3">
            <HeadingWIcon {...press} colors={headingStyles} small />
          </div>
          <div className="mt-4 w-auto flex-shrink-0 pt-4 md:mt-0">
            <ButtonAlt icon="search" reverse color="gold" onClick={openSearch}>
              Search {press.heading}
            </ButtonAlt>
          </div>
        </div>
        <ul className="mt-8 grid flex-col gap-8 sm:grid-cols-2 md:mt-12 md:gap-12">
          {press.documents.slice(0, 6).map(d => (
            <li key={d.uid} className="w-full">
              <PressTease {...d} />
            </li>
          ))}
        </ul>
        <div className="mt-12">
          <ButtonAlt onClick={openSearch} color="gold">
            More {press.heading}
          </ButtonAlt>
        </div>
      </Container>
    </div>
  );
};

export default PressGrid;
